define(function(require) {
    var IpsModel = require('civicsBase/ipsModel');
    return IpsModel.extend({
      validation:{
        name:{
          required: true,
        }
      },
      urlRoot: '/delegate/civics-api/api/portal/scenarios'
    });
});
